import React, { useState } from 'react';

const MainMenu = ({ onCategorySelect }) => {
  const [showInstructions, setShowInstructions] = useState(false);

  // Function to open the instructions overlay
  const openInstructions = () => {
    setShowInstructions(true);
  };

  // Function to close the instructions overlay
  const closeInstructions = () => {
    setShowInstructions(false);
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen px-4 relative">
      <h1 className="text-5xl mb-6 font-bold text-gray-900">Truth or Drink</h1>
      <p className="text-xl mb-8 text-gray-700">Select a card deck to begin:</p>

      {/* Category Buttons */}
      <button
        onClick={() => onCategorySelect("HappyHour")}
        className="category-button mb-4 bg-gradient-to-r from-blue-400 to-blue-600 text-white font-semibold text-lg px-8 py-6 rounded-2xl shadow-2xl hover:scale-105 transition-all"
      >
        🍹 Happy Hour
      </button>
      <button
        onClick={() => onCategorySelect("OnTheRocks")}
        className="category-button mb-4 bg-gradient-to-r from-green-400 to-green-600 text-white font-semibold text-lg px-8 py-6 rounded-2xl shadow-2xl hover:scale-105 transition-all"
      >
        🥃 On The Rocks
      </button>
      <button
        onClick={() => onCategorySelect("LastCall")}
        className="category-button mb-4 bg-gradient-to-r from-yellow-400 to-yellow-600 text-white font-semibold text-lg px-8 py-6 rounded-2xl shadow-2xl hover:scale-105 transition-all"
      >
        🍸 Last Call
      </button>
      <button
        onClick={() => onCategorySelect("ExtraDirty")}
        className="category-button mb-4 bg-gradient-to-r from-red-400 to-red-600 text-white font-semibold text-lg px-8 py-6 rounded-2xl shadow-2xl hover:scale-105 transition-all"
      >
        🍷 Extra Dirty
      </button>

      {/* Instructions Button */}
      <button
        onClick={openInstructions}
        className="mt-10 mb-4 bg-gradient-to-r from-purple-500 to-indigo-600 text-white font-bold px-6 py-3 rounded-full shadow-lg hover:scale-105 transition-all"
      >
        Instructions
      </button>

      {/* Instructions Overlay */}
      {showInstructions && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
          onClick={closeInstructions}
        >
          <div
            className="bg-white p-4 rounded-lg shadow-lg max-w-lg w-full"
            onClick={(e) => e.stopPropagation()} // Prevent click from closing when clicking inside the box
          >
            <img
              src="/images/instructions.png"
              alt="Instructions"
              className="max-w-full h-auto"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default MainMenu;
